import { useState } from "react";
import { MessageSquare, Cpu, CornerDownRight } from "lucide-react";

export function LandingDualMode() {
  return (
    <section className="border-b-2 border-black bg-zinc-50 py-24 select-none relative overflow-hidden font-mono">
      <div className="max-w-4xl mx-auto px-6 flex flex-col items-center">
        {/* Toggle Title */}
        <p className="text-xs mb-4 uppercase tracking-wider font-bold text-gray-500">[INTEGRATION INTERACTION]</p>
        <h2 className="text-3xl md:text-4xl font-black uppercase text-center leading-none">
          Ask Anything. Right in ChatGPT.
        </h2>
        <p className="text-zinc-600 mt-4 text-xs font-bold uppercase max-w-lg text-center font-sans">
          Talk to UptimeWing through ChatGPT. No dashboard needed.
        </p>

        {/* Visual Map Layout - ChatGPT Dialog mockup */}
        <div className="w-full max-w-xl mt-12 border-4 border-black bg-white p-6 shadow-[6px_6px_0_0_#000] relative space-y-4 text-xs font-mono">
          <div className="flex items-center gap-2 border-b border-black pb-2">
            <MessageSquare className="w-4 h-4 text-primary" />
            <span className="font-black uppercase tracking-tight">ChatGPT Session</span>
          </div>

          <div className="space-y-4">
            {/* User prompt */}
            <div className="space-y-1 bg-zinc-100 p-3 border border-zinc-200">
              <span className="font-black text-black">You:</span>
              <p className="font-medium text-zinc-700">what broke in api-prod today?</p>
            </div>

            {/* Response */}
            <div className="space-y-1.5 bg-zinc-950 text-white p-4 border-2 border-black">
              <span className="font-black text-primary">UptimeWing:</span>
              <p className="text-[10px] text-zinc-300 leading-normal">
                2 incidents detected.<br />
                • 14:02 - Deploy 241 caused DB timeout. Fixed via rollback.<br />
                • 14:47 - SSL expired. Fixed via certbot renew.
              </p>
            </div>

            {/* User prompt 2 */}
            <div className="space-y-1 bg-zinc-100 p-3 border border-zinc-200">
              <span className="font-black text-black">You:</span>
              <p className="font-medium text-zinc-700">why is checkout slow right now?</p>
            </div>

            {/* Response 2 */}
            <div className="space-y-1.5 bg-zinc-950 text-white p-4 border-2 border-black">
              <span className="font-black text-primary">UptimeWing:</span>
              <p className="text-[10px] text-zinc-300 leading-normal">
                Checkout endpoint +200ms latency spike since 15:00.<br />
                Redis memory matches 92% footprint capacity.<br />
                Fix: Scale Redis cluster threads or flush cache records.
              </p>
            </div>
          </div>

          <div className="pt-4 border-t border-zinc-150 flex flex-col items-center gap-3">
            <a 
              href="https://chatgpt.com/g/g-6a3addaa2cc08191892da92fea5073a5-uptimewing" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-[#FFFF00] text-black border-2 border-black font-black uppercase text-[10px] px-6 py-2.5 shadow-[2px_2px_0_0_#000] hover:shadow-none hover:translate-x-[2px] hover:translate-y-[2px] transition-all"
            >
              Try UptimeWing Custom GPT →
            </a>
            <p className="font-mono text-[9px] text-zinc-400 font-black uppercase tracking-widest text-center">
              You already live in ChatGPT. Now your incidents do too. Then it's as simple as talking.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
